import { useEffect, useState } from "react";
import { SkillModel } from "../api/models/RecitationSkillsModel";
import { SkillsService } from "../services/SkillsService/SkillsService";

export function useSkills(
  finishedSkills: string[],
  onUpdate: (finishedSkills: string[]) => Promise<boolean> = async () => true
) {
  const [skillsService, setSkillsService] = useState<SkillsService>();
  const [skills, setSkills] = useState<SkillModel[]>();
  const [search, setSearch] = useState<string>();
  useEffect(() => {
    const skillsService = new SkillsService(finishedSkills);
    setSkillsService(skillsService);
  }, []);

  useEffect(() => {
    if (!!search) {
      setSkills(skillsService?.searchSkills(search) || []);
    } else {
      setSkills(skillsService?.skills || []);
    }
  }, [search, skillsService]);

  const onSkillClick = async (skill: SkillModel) => {
    skillsService?.toggleSkillStatus(skill.hashedPath);
    if (!(await onUpdate(skillsService?.completedSkills || [])))
      skillsService?.toggleSkillStatus(skill.hashedPath);

    if (!!search) {
      setSkills(skillsService?.searchSkills(search) || []);
    } else {
      setSkills(skillsService?.skills || []);
    }
  };

  const setFinishedSkills = (finishedSkills: string[]) => {
    const skillsService = new SkillsService(finishedSkills);
    setSkillsService(skillsService);
  };

  return { skills, onSkillClick, setSearch, setFinishedSkills };
}
